/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class Authorization {
    getFixupPrototypeFunction() { return Authorization.fixupPrototype; }

    static newInstance(model: Partial<Authorization>): Authorization {
        let obj = Object.assign(new Authorization(), model);
        Authorization.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<Authorization>): Authorization {
        if (!model) return null;
        return Authorization.newInstance(<Authorization> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: Authorization) {
        if (!obj) return;

        models.Authorization.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: Authorization): boolean {
        Object.setPrototypeOf(obj, Authorization.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * DateTime in UTC when the token was issued.
     */
    issued_at: string;

    /**
     * Token expiry datetime in UTC.
     */
    expires_at: string;

    /**
     * This will be used as X-Auth-Token in all other APIs.
     */
    access_token: string;

}
